<h2 mat-dialog-title>
  <span
    [matTooltip]="
      data.workingContractCareerPlan.is_active ? 'Plan actual' : data.workingContractCareerPlan.is_future ? 'Plan futuro' : 'Plan pasado'
    "
    style="margin-right: 8px"
  >
    {{ data.workingContractCareerPlan.is_active ? '🟢' : data.workingContractCareerPlan.is_future ? '🔵' : '⚫' }}
  </span>
  Años del plan de carrera
</h2>

<mat-dialog-content>
  <table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef>Año</th>
      <td mat-cell *matCellDef="let year">{{ year.year }}</td>
    </ng-container>

    <ng-container matColumnDef="department_categories">
      <th mat-header-cell *matHeaderCellDef>Departamentos</th>
      <td mat-cell *matCellDef="let year">
        @if (editingYearId !== year.id) {
          <div class="categories-list">
            @for (category of year.department_categories; track category.id) {
              <span class="category-tag">
                {{ category.name }}
              </span>
            }
          </div>
        } @else {
          <form [formGroup]="editForm">
            <mat-form-field class="categories-field">
              <mat-select formControlName="department_categories_ids" multiple>
                @for (category of departmentCategories; track category.id) {
                  <mat-option [value]="category.id">
                    {{ category.name }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </form>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="custom_brute_anual_base_salary">
      <th mat-header-cell *matHeaderCellDef>Salario bruto anual</th>
      <td mat-cell *matCellDef="let year">
        @if (editingYearId !== year.id) {
          @if (year.custom_brute_anual_base_salary) {
            {{ year.custom_brute_anual_base_salary | currency }}
          } @else {
            Por defecto
            <div style="font-size: 12px; color: #888">
              <span>({{ year.default_salary_with_seniority | currency }})</span>
            </div>
          }
        } @else {
          <form [formGroup]="editForm">
            <div class="salary-edit">
              <mat-checkbox formControlName="use_default_salary" (change)="onEditUseDefaultSalaryChange($event.checked)">
                Por defecto
              </mat-checkbox>
              @if (!editForm.get('use_default_salary')?.value) {
                <mat-form-field style="max-width: 100px">
                  <input matInput type="number" formControlName="custom_brute_anual_base_salary" min="1" />
                </mat-form-field>
              }
            </div>
          </form>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="custom_weekly_hours">
      <th mat-header-cell *matHeaderCellDef>Horas semanales</th>
      <td mat-cell *matCellDef="let year">
        @if (editingYearId !== year.id) {
          @if (year.custom_weekly_hours_str) {
            {{ year.custom_weekly_hours_str }}
          } @else {
            Por defecto
            <div style="font-size: 12px; color: #888">
              <span>({{ year.default_hours_per_week_expected_str }})</span>
            </div>
          }
        } @else {
          <form [formGroup]="editForm">
            <div class="salary-edit">
              <mat-checkbox formControlName="use_default_hours" (change)="onEditUseDefaultHoursChange($event.checked)">
                Por defecto
              </mat-checkbox>
              @if (!editForm.get('use_default_hours')?.value) {
                <mat-form-field style="max-width: 120px">
                  <input matInput type="number" formControlName="custom_weekly_hours" min="0.01" step="0.01" />
                </mat-form-field>
              }
            </div>
          </form>
        }
      </td>
    </ng-container>

    @if (!data.workingContractCareerPlan.is_active && !data.workingContractCareerPlan.is_past) {
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Acciones</th>
        <td mat-cell *matCellDef="let year">
          @if (editingYearId !== year.id) {
            <button mat-icon-button color="primary" (click)="startEdit(year)" matTooltip="Editar">
              <mat-icon>edit</mat-icon>
            </button>
          } @else {
            <div class="actions-cell">
              <button mat-icon-button color="primary" (click)="saveEdit(year)" [disabled]="!editForm.valid" matTooltip="Guardar">
                <mat-icon>save</mat-icon>
              </button>
              <button mat-icon-button color="warn" (click)="cancelEdit()" matTooltip="Cancelar">
                <mat-icon>close</mat-icon>
              </button>
            </div>
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.editing]="editingYearId === row.id"></tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]"></mat-paginator>
</mat-dialog-content>
